import { render, staticRenderFns } from "./exchange.vue?vue&type=template&id=2b1fedfd&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=ts&setup=true"
export * from "./exchange.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./exchange.vue?vue&type=style&index=0&id=2b1fedfd&prod&lang=less"
import style1 from "./exchange.vue?vue&type=style&index=1&id=2b1fedfd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fedfd",
  null
  
)

export default component.exports